import React from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import AuthPersist from './components/AuthPersist/AuthPersist';
import PageLoader from './components/feedback/PageLoader';
import AppRoutes from './routes/AppRoutes';
import './App.css';

function AppContent() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <PageLoader minHeight="100vh" />;
  }

  return (
    <div className="app">
      <AppRoutes isAuthenticated={isAuthenticated} />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AuthPersist>
        <AppContent />
      </AuthPersist>
    </AuthProvider>
  );
}

export default App;
